<template>
  <div>
    <div class="form-group mb-4">
      <p>
        Durante el desarrollo del proyecto se utilizarán microorganismos (virus, bacterias, parásito, etc)
        potencialmente infecciosos?
      </p>
      
      <!-- Question 5 -->
      <div class="form-check form-check-inline">
        <input id="question-5-radio-1" :checked="questionnaire.question_5"
               aria-expanded="false"
               class="form-check-input show-collapse collapsed" data-target=".question-5-collapse:not(.show)" data-toggle="collapse"
               name="question_5"
               type="radio"
               value="1"
               @change="addValidation('question_5')">
        <label class="form-check-label"
               for="question-5-radio-1">Si</label>
      </div>
      <div class="form-check form-check-inline">
        <input id="question-5-radio-2" :checked="questionnaire.question_5 === false"
               class="form-check-input"
               data-target=".question-5-collapse.show" data-toggle="collapse" name="question_5"
               type="radio"
               value=""
               @change="removeValidation('question_5')">
        <label class="form-check-label"
               for="question-5-radio-2">No</label>
      </div>
      <div data-name="question_5"></div>
    </div>
    
    <div :class="{ 'show': questionnaire.question_5 }" class="question-5-collapse collapse">
      <div class="form-group mb-4">
        <microorganisms-list :microorganisms="questionnaire.microorganisms"></microorganisms-list>
        <input id="microorganisms_hidden" name="microorganisms_hidden" type="hidden">
      </div>
      
      <div class="form-group mb-4">
        <label for="microorganisms_rpbi_type">Tipo de RPBI</label>
        <textarea id="microorganisms_rpbi_type"
                  v-model="questionnaire.microorganisms_rpbi_type"
                  class="form-control "
                  cols="50"
                  name="microorganisms_rpbi_type"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      
      <div class="form-group mb-4">
        <label for="microorganisms_waste_disposal_methods">
          Especifique los métodos de eliminación del desecho generado, describiendo detalladamente
          el tipo de contenedor en que se eliminará y/o el tratamiento que aplicará.
        </label>
        <textarea id="microorganisms_waste_disposal_methods"
                  v-model="questionnaire.microorganisms_waste_disposal_methods"
                  class="form-control "
                  cols="50"
                  name="microorganisms_waste_disposal_methods"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      
      <div class="form-group mb-4">
        <label for="microorganisms_place_frequency_of_disposal">
          Lugar y frecuencia de desecho:
        </label>
        <textarea id="microorganisms_place_frequency_of_disposal"
                  v-model="questionnaire.microorganisms_place_frequency_of_disposal"
                  class="form-control "
                  cols="50"
                  name="microorganisms_place_frequency_of_disposal"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
    </div>
    
    <div class="form-group mb-4">
      <p>
        El protocolo implica el uso de muestras biológicas de origen:
      </p>
      
      <!-- Question 6 -->
      <div class="form-check form-check-inline">
        <input id="question-6-radio-1" :checked="questionnaire.question_6"
               aria-expanded="false"
               class="form-check-input show-collapse collapsed" data-target=".question-6-collapse:not(.show)" data-toggle="collapse"
               name="question_6"
               type="radio"
               value="1"
               @change="addValidation('question_6')">
        <label class="form-check-label"
               for="question-6-radio-1">Si</label>
      </div>
      <div class="form-check form-check-inline">
        <input id="question-6-radio-2" :checked="questionnaire.question_6 === false"
               class="form-check-input"
               data-target=".question-6-collapse.show" data-toggle="collapse" name="question_6"
               type="radio"
               value=""
               @change="removeValidation('question_6')">
        <label class="form-check-label"
               for="question-6-radio-2">No</label>
      </div>
      <div data-name="question_6"></div>
    </div>
    
    <div :class="{ 'show': questionnaire.question_6 }" class="question-6-collapse collapse">
      <div class="form-group mb-4">
        <p>
          Especifique el origen:
        </p>
        <div class="form-check">
          <input id="biological_samples_checkbox_1"
                 v-model="questionnaire.biological_samples"
                 class="form-check-input"
                 name="biological_samples"
                 type="checkbox"
                 value="Humano">
          <label class="form-check-label font-weight-normal"
                 for="biological_samples_checkbox_1">
            Humano
          </label>
        </div>
        <div class="form-check">
          <input id="biological_samples_checkbox_2"
                 v-model="questionnaire.biological_samples"
                 class="form-check-input"
                 name="biological_samples"
                 type="checkbox"
                 value="Animal">
          <label class="form-check-label font-weight-normal"
                 for="biological_samples_checkbox_2">
            Animal
          </label>
        </div>
        <div class="form-check mb-2">
          <input id="biological_samples_checkbox_3"
                 v-model="questionnaire.biological_samples"
                 class="form-check-input"
                 name="biological_samples"
                 type="checkbox"
                 value="Otro"
                 @change="addValidationByCheckbox($event, 'biological_samples_other')">
          <label class="form-check-label font-weight-normal"
                 for="biological_samples_checkbox_3">
            Otro
          </label>
        </div>
        <div :class="{ 'd-none': (questionnaire.biological_samples && !questionnaire.biological_samples.includes('Otro')) }"
             class="form-group mb-4 mt-2">
          <textarea id="biological_samples_other"
                    v-model="questionnaire.biological_samples_other"
                    class="form-control "
                    cols="50"
                    name="biological_samples_other"
                    placeholder="Explique el origen de las muestras..."
                    rows="2"></textarea>
        </div>
        <div data-name="biological_samples"></div>
      </div>
      <div class="form-group mb-4">
        <p>
          Especifique el tipo de muestras:
        </p>
        <div class="form-check">
          <input id="biological_samples_types_checkbox_1"
                 v-model="questionnaire.biological_samples_types"
                 class="form-check-input"
                 name="biological_samples_types"
                 type="checkbox"
                 value="Sangre y/o sus derivados">
          <label class="form-check-label font-weight-normal"
                 for="biological_samples_types_checkbox_1">
            Sangre y/o sus derivados
          </label>
        </div>
        <div class="form-check">
          <input id="biological_samples_types_checkbox_2"
                 v-model="questionnaire.biological_samples_types"
                 class="form-check-input"
                 name="biological_samples_types"
                 type="checkbox"
                 value="Líquido cefalorraquídeo">
          <label class="form-check-label font-weight-normal"
                 for="biological_samples_types_checkbox_2">
            Líquido cefalorraquídeo
          </label>
        </div>
        <div class="form-check">
          <input id="biological_samples_types_checkbox_3"
                 v-model="questionnaire.biological_samples_types"
                 class="form-check-input"
                 name="biological_samples_types"
                 type="checkbox"
                 value="Aspirado/lavado/exudado">
          <label class="form-check-label font-weight-normal"
                 for="biological_samples_types_checkbox_3">
            Aspirado/lavado/exudado
          </label>
        </div>
        <div class="form-check">
          <input id="biological_samples_types_checkbox_4"
                 v-model="questionnaire.biological_samples_types"
                 class="form-check-input"
                 name="biological_samples_types"
                 type="checkbox"
                 value="Biopsia"
                 @change="addValidationByCheckbox($event, 'biological_samples_biopsy')">
          <label class="form-check-label font-weight-normal"
                 for="biological_samples_types_checkbox_4">
            Biopsia (de____________)
          </label>
        </div>
        <div :class="{ 'd-none': (questionnaire.biological_samples_types && !questionnaire.biological_samples_types.includes('Biopsia')) }"
             class="form-group mb-2 mt-2">
          <input id="biological_samples_biopsy"
                 v-model="questionnaire.biological_samples_biopsy"
                 class="form-control"
                 name="biological_samples_biopsy"
                 placeholder="Ingrese el tipo de biopsia..."
                 type="text">
        </div>
        <div class="form-check">
          <input id="biological_samples_types_checkbox_5"
                 v-model="questionnaire.biological_samples_types"
                 class="form-check-input"
                 name="biological_samples_types"
                 type="checkbox"
                 value="Cultivos"
                 @change="addValidationByCheckbox($event, 'biological_samples_culture')">
          <label class="form-check-label font-weight-normal"
                 for="biological_samples_types_checkbox_5">
            Cultivos (de___________)
          </label>
        </div>
        <div :class="{ 'd-none': (questionnaire.biological_samples_types && !questionnaire.biological_samples_types.includes('Cultivos')) }"
             class="form-group mb-2 mt-2">
          <input id="biological_samples_culture"
                 v-model="questionnaire.biological_samples_culture"
                 class="form-control"
                 name="biological_samples_culture"
                 placeholder="Ingrese el tipo de cultivos..."
                 type="text">
        </div>
        <div class="form-check">
          <input id="biological_samples_types_checkbox_6"
                 v-model="questionnaire.biological_samples_types"
                 class="form-check-input"
                 name="biological_samples_types"
                 type="checkbox"
                 value="Necropsia">
          <label class="form-check-label font-weight-normal"
                 for="biological_samples_types_checkbox_6">
            Necropsia
          </label>
        </div>
        <div class="form-check">
          <input id="biological_samples_types_checkbox_7"
                 v-model="questionnaire.biological_samples_types"
                 class="form-check-input"
                 name="biological_samples_types"
                 type="checkbox"
                 value="Otras"
                 @change="addValidationByCheckbox($event, 'biological_samples_other_types')">
          <label class="form-check-label font-weight-normal"
                 for="biological_samples_types_checkbox_7">
            Otras (describa)
          </label>
        </div>
        <div :class="{ 'd-none': (questionnaire.biological_samples_types && !questionnaire.biological_samples_types.includes('Otras')) }"
             class="form-group mb-2 mt-2">
          <textarea id="biological_samples_other_types"
                    v-model="questionnaire.biological_samples_other_types"
                    class="form-control"
                    cols="50"
                    name="biological_samples_other_types"
                    placeholder="Describa el tipo de muestras..."
                    rows="2"></textarea>
        </div>
        <div data-name="biological_samples_types"></div>
      </div>
      <div class="form-group mb-4">
        <label for="biological_samples_place_for_sampling">
          Especifique el lugar en dónde se realizará la toma de muestras:
        </label>
        <textarea id="biological_samples_place_for_sampling"
                  v-model="questionnaire.biological_samples_place_for_sampling"
                  class="form-control "
                  cols="50"
                  name="biological_samples_place_for_sampling"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      <div class="form-group mb-4">
        <label for="biological_samples_place_to_process">
          Especifique el lugar en dónde se procesarán las muestras:
        </label>
        <textarea id="biological_samples_place_to_process"
                  v-model="questionnaire.biological_samples_place_to_process"
                  class="form-control "
                  cols="50"
                  name="biological_samples_place_to_process"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      <div class="form-group mb-4">
        <label for="biological_samples_rpbi_type">
          Tipo de RPBI:
        </label>
        <textarea id="biological_samples_rpbi_type"
                  v-model="questionnaire.biological_samples_rpbi_type"
                  class="form-control "
                  cols="50"
                  name="biological_samples_rpbi_type"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      <div class="form-group mb-4">
        <label for="biological_samples_removal_methods">
          Especifique los métodos de eliminación del desecho generado, describiendo detalladamente el tipo de contenedor
          en
          que se eliminará y/o el tratamiento que aplicará:
        </label>
        <textarea id="biological_samples_removal_methods"
                  v-model="questionnaire.biological_samples_removal_methods"
                  class="form-control "
                  cols="50"
                  name="biological_samples_removal_methods"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      <div class="form-group mb-4">
        <label for="biological_samples_place_frequency_of_disposal">
          Lugar y frecuencia de desecho:
        </label>
        <textarea id="biological_samples_place_frequency_of_disposal"
                  v-model="questionnaire.biological_samples_place_frequency_of_disposal"
                  class="form-control "
                  cols="50"
                  name="biological_samples_place_frequency_of_disposal"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
    </div>
    
    <div class="form-group mb-4">
      <p>
        El proyecto contempla el cultivo de líneas celulares:
      </p>
      
      <!-- Question 7 -->
      <div class="form-check form-check-inline">
        <input id="question-7-radio-1" :checked="questionnaire.question_7"
               aria-expanded="false"
               class="form-check-input show-collapse collapsed" data-target=".question-7-collapse:not(.show)" data-toggle="collapse"
               name="question_7"
               type="radio"
               value="1"
               @change="addValidation('question_7')">
        <label class="form-check-label"
               for="question-7-radio-1">Si</label>
      </div>
      <div class="form-check form-check-inline">
        <input id="question-7-radio-2" :checked="questionnaire.question_7 === false"
               class="form-check-input"
               data-target=".question-7-collapse.show" data-toggle="collapse" name="question_7"
               type="radio"
               value=""
               @change="removeValidation('question_7')">
        <label class="form-check-label"
               for="question-7-radio-2">No</label>
      </div>
      <div data-name="question_7"></div>
    </div>
    
    <div :class="{ 'show': questionnaire.question_7 }" class="question-7-collapse collapse">
      <div class="form-group mb-4">
        <cell-lines-list :cellLines="questionnaire.cell_lines"></cell-lines-list>
        <input id="cell_lines_hidden" name="cell_lines_hidden" type="hidden">
      </div>
      
      <div class="form-group mb-4">
        <label for="cell_line_culture_rpbi_type">Tipo de RPBI:</label>
        <textarea id="cell_line_culture_rpbi_type"
                  v-model="questionnaire.cell_line_culture_rpbi_type"
                  class="form-control "
                  cols="50"
                  name="cell_line_culture_rpbi_type"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      
      <div class="form-group mb-4">
        <label for="cell_line_culture_removal_methods">
          Especifique los métodos de eliminación del desecho generado, describiendo detalladamente el tipo de contenedor
          en que se eliminará y/o el tratamiento que aplicará
        </label>
        <textarea id="cell_line_culture_removal_methods"
                  v-model="questionnaire.cell_line_culture_removal_methods"
                  class="form-control "
                  cols="50"
                  name="cell_line_culture_removal_methods"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      
      <div class="form-group mb-4">
        <label for="cell_line_culture_place_frequency_of_disposal">
          Lugar y frecuencia de desecho
        </label>
        <textarea id="cell_line_culture_place_frequency_of_disposal"
                  v-model="questionnaire.cell_line_culture_place_frequency_of_disposal"
                  class="form-control "
                  cols="50"
                  name="cell_line_culture_place_frequency_of_disposal"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
    </div>
    
    <div class="form-group mb-4">
      <p>
        El proyecto contempla el uso de material genéticamente modificado. (bacterias o parásitos recombinantes,
        plásmidos, vectores)?
      </p>
      
      <!-- Question 8 -->
      <div class="form-check form-check-inline">
        <input id="question-8-radio-1" :checked="questionnaire.question_8"
               aria-expanded="false"
               class="form-check-input show-collapse collapsed" data-target=".question-8-collapse:not(.show)" data-toggle="collapse"
               name="question_8"
               type="radio"
               value="1"
               @change="addValidation('question_8')">
        <label class="form-check-label"
               for="question-8-radio-1">Si</label>
      </div>
      <div class="form-check form-check-inline">
        <input id="question-8-radio-2" :checked="questionnaire.question_8 === false"
               class="form-check-input"
               data-target=".question-8-collapse.show" data-toggle="collapse" name="question_8"
               type="radio"
               value=""
               @change="removeValidation('question_8')">
        <label class="form-check-label"
               for="question-8-radio-2">No</label>
      </div>
      <div data-name="question_8"></div>
    </div>
    
    <div :class="{ 'show': questionnaire.question_8 }" class="question-8-collapse collapse">
      <div class="form-group mb-4">
        <label for="genetically_modified_material">¿Cuáles?</label>
        <textarea id="genetically_modified_material"
                  v-model="questionnaire.genetically_modified_material"
                  class="form-control"
                  cols="50"
                  name="genetically_modified_material"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      
      <div class="form-group mb-4">
        <label for="genetically_modified_material_nature">
          Si el material genético codifica para algún factor de patogenicidad o toxina o algún gen inmunomodulador por
          favor
          explique la naturaleza y el efecto de este gen:
        </label>
        <textarea id="genetically_modified_material_nature"
                  v-model="questionnaire.genetically_modified_material_nature"
                  class="form-control"
                  cols="50"
                  name="genetically_modified_material_nature"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      
      <div class="form-group mb-4">
        <label for="genetically_modified_material_xenotransplantation">
          Si involucra xenotransplantes o infección en mamíferos (conejos, ratones, ratas) u otro organismo (mosquitos,
          chinches,
          u otro) por favor describa la naturaleza y efectos esperados.
        </label>
        <textarea id="genetically_modified_material_xenotransplantation"
                  v-model="questionnaire.genetically_modified_material_xenotransplantation"
                  class="form-control"
                  cols="50"
                  name="genetically_modified_material_xenotransplantation"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      
      <div class="form-group mb-4">
        <label for="genetically_modified_material_risks">
          Describa cuál o cuáles son los riesgos que su expresión representa y los mecanismos de contención:
        </label>
        <textarea id="genetically_modified_material_risks"
                  v-model="questionnaire.genetically_modified_material_risks"
                  class="form-control"
                  cols="50"
                  name="genetically_modified_material_risks"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      
      <div class="form-group mb-4">
        <label for="genetically_modified_material_removal_methods">
          Especifique los métodos de eliminación del desecho generado, describiendo detalladamente el tipo de contenedor
          en que se
          eliminará y/o el tratamiento que aplicará
        </label>
        <textarea id="genetically_modified_material_removal_methods"
                  v-model="questionnaire.genetically_modified_material_removal_methods"
                  class="form-control"
                  cols="50"
                  name="genetically_modified_material_removal_methods"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      
      <div class="form-group mb-4">
        <label for="genetically_modified_place_frequency_of_disposal">
          Lugar y frecuencia de desecho
        </label>
        <textarea id="genetically_modified_place_frequency_of_disposal"
                  v-model="questionnaire.genetically_modified_place_frequency_of_disposal"
                  class="form-control"
                  cols="50"
                  name="genetically_modified_place_frequency_of_disposal"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
    </div>
    
    <div class="form-group mb-4">
      <p>
        En el proyecto se manejarán muestras ambientales?
      </p>
      
      <!-- Question 9 -->
      <div class="form-check form-check-inline">
        <input id="question-9-radio-1" :checked="questionnaire.question_9"
               aria-expanded="false"
               class="form-check-input show-collapse collapsed" data-target=".question-9-collapse:not(.show)" data-toggle="collapse"
               name="question_9"
               type="radio"
               value="1"
               @change="addValidation('question_9')">
        <label class="form-check-label"
               for="question-9-radio-1">Si</label>
      </div>
      <div class="form-check form-check-inline">
        <input id="question-9-radio-2" :checked="questionnaire.question_9 === false"
               class="form-check-input"
               data-target=".question-9-collapse.show" data-toggle="collapse" name="question_9"
               type="radio"
               value=""
               @change="removeValidation('question_9')">
        <label class="form-check-label"
               for="question-9-radio-2">No</label>
      </div>
      <div data-name="question_9"></div>
    </div>
    
    <div :class="{ 'show': questionnaire.question_9 }" class="question-9-collapse collapse">
      <div class="form-group mb-4">
        <label for="environmental_samples_type">Señale tipo de muestra</label>
        <textarea id="environmental_samples_type"
                  v-model="questionnaire.environmental_samples_type"
                  class="form-control"
                  cols="50"
                  name="environmental_samples_type"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      
      <div class="form-group mb-4">
        <label for="environmental_samples_risks">¿Cuáles son los riesgos que este tipo de muestras implican?</label>
        <textarea id="environmental_samples_risks"
                  v-model="questionnaire.environmental_samples_risks"
                  class="form-control"
                  cols="50"
                  name="environmental_samples_risks"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      
      <div class="form-group mb-4">
        <label for="environmental_samples_rpbi_type">Tipo de RPBI</label>
        <textarea id="environmental_samples_rpbi_type"
                  v-model="questionnaire.environmental_samples_rpbi_type"
                  class="form-control"
                  cols="50"
                  name="environmental_samples_rpbi_type"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      
      <div class="form-group mb-4">
        <label for="environmental_samples_disposal_methods">
          Especifique los métodos de eliminación del desecho generado, describiendo detalladamente el tipo de contenedor
          en que se eliminará y/o
          el tratamiento que aplicará.
        </label>
        <textarea id="environmental_samples_disposal_methods"
                  v-model="questionnaire.environmental_samples_disposal_methods"
                  class="form-control"
                  cols="50"
                  name="environmental_samples_disposal_methods"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
      
      <div class="form-group mb-4">
        <label for="environmental_samples_place_frequency_of_disposal">
          Lugar y frecuencia de desecho:
        </label>
        <textarea id="environmental_samples_place_frequency_of_disposal"
                  v-model="questionnaire.environmental_samples_place_frequency_of_disposal"
                  class="form-control"
                  cols="50"
                  name="environmental_samples_place_frequency_of_disposal"
                  placeholder="Escriba su respuesta..."
                  rows="5"></textarea>
      </div>
    </div>
    
    <div class="form-group mb-4">
      <p>
        ¿El proyecto implica el traslado de las muestras biológicas (de origen humano, animal, ambiental o aislamiento
        clínico)
        o los RPBIs generados, al INSP o a alguna otra institución (nacional o internacional)?
      </p>
      
      <!-- Question 10 -->
      <div class="form-check form-check-inline">
        <input id="question-10-radio-1" :checked="questionnaire.question_10"
               aria-expanded="false"
               class="form-check-input show-collapse collapsed" data-target=".question-10-collapse:not(.show)" data-toggle="collapse"
               name="question_10"
               type="radio"
               value="1"
               @change="addValidation('question_10')">
        <label class="form-check-label"
               for="question-10-radio-1">Si</label>
      </div>
      <div class="form-check form-check-inline">
        <input id="question-10-radio-2" :checked="questionnaire.question_10 === false"
               class="form-check-input"
               data-target=".question-10-collapse.show" data-toggle="collapse" name="question_10"
               type="radio"
               value=""
               @change="removeValidation('question_10')">
        <label class="form-check-label"
               for="question-10-radio-2">No</label>
      </div>
      <div data-name="question_10"></div>
    </div>
    
    <div :class="{ 'show': questionnaire.question_10 }" class="question-10-collapse collapse">
      <div class="form-group mb-4">
        <label for="biological_sample_transfer_origin">Institución o lugar de origen:</label>
        <input id="biological_sample_transfer_origin"
               v-model="questionnaire.biological_sample_transfer_origin"
               class="form-control"
               name="biological_sample_transfer_origin"
               placeholder="Escriba su respuesta"
               type="text">
      </div>
      
      <div class="form-group mb-4">
        <label for="biological_sample_transfer_destination">Institución a la que será trasladada:</label>
        <input id="biological_sample_transfer_destination"
               v-model="questionnaire.biological_sample_transfer_destination"
               class="form-control"
               name="biological_sample_transfer_destination"
               placeholder="Escriba su respuesta"
               type="text">
      </div>
      
      <div class="form-group mb-4">
        <label for="biological_sample_transfer_classification">Clasificación (Categoría A, Categoría B o
                                                               exento):</label>
        <input id="biological_sample_transfer_classification"
               v-model="questionnaire.biological_sample_transfer_classification"
               class="form-control"
               name="biological_sample_transfer_classification"
               placeholder="Escriba su respuesta"
               type="text">
      </div>
      
      <div class="form-group mb-4">
        <label for="biological_sample_transfer_packing_type">Qué tipo de embalaje será utilizado y con qué leyenda será
                                                             etiquetado:</label>
        <textarea id="biological_sample_transfer_packing_type"
                  v-model="questionnaire.biological_sample_transfer_packing_type"
                  class="form-control"
                  cols="50"
                  name="biological_sample_transfer_packing_type"
                  placeholder="Escriba su respuesta"
                  rows="5"></textarea>
      </div>
      
      <div class="form-group mb-4">
        <label for="biological_sample_transfer_conveyance">Por qué medio:</label>
        <input id="biological_sample_transfer_conveyance"
               v-model="questionnaire.biological_sample_transfer_conveyance"
               class="form-control"
               name="biological_sample_transfer_conveyance"
               placeholder="Escriba su respuesta"
               type="text">
      </div>
      
      <div class="form-group mb-4">
        <label for="biological_sample_transfer_responsible_for_shipping">Quién será el responsable del envío:</label>
        <input id="biological_sample_transfer_responsible_for_shipping"
               v-model="questionnaire.biological_sample_transfer_responsible_for_shipping"
               class="form-control"
               name="biological_sample_transfer_responsible_for_shipping"
               placeholder="Escriba su respuesta"
               type="text">
      </div>
      
      <div class="form-group mb-4">
        <label for="biological_sample_transfer_responsible_for_receiving">Quién será responsable en la Institución
                                                                          Receptora:</label>
        <input id="biological_sample_transfer_responsible_for_receiving"
               v-model="questionnaire.biological_sample_transfer_responsible_for_receiving"
               class="form-control"
               name="biological_sample_transfer_responsible_for_receiving"
               placeholder="Escriba su respuesta"
               type="text">
      </div>
      
      <div class="form-group mb-4">
        <label for="biological_sample_transfer_periodicity">Especifique periodicidad, horario:</label>
        <input id="biological_sample_transfer_periodicity"
               v-model="questionnaire.biological_sample_transfer_periodicity"
               class="form-control"
               name="biological_sample_transfer_periodicity"
               placeholder="Escriba su respuesta"
               type="text">
      </div>
      
      <div class="form-group mb-4">
        <p class="text-muted">
          Nota: Si el sitio al que serán trasladados las muestras y/o los desechos es externo al INSP deberá entregarse
          a la
          Comisión de Bioseguridad el original de la carta responsiva de la(s) Institución(es) colaboradora(s) por el
          manejo
          de muestras (biocustodia) y la adecuada disposición de los residuos (RPBI y CRETI); asimismo deberá(n)
          incorporarse
        </p>
        
        <div v-if="questionnaire.biological_sample_transfer_letter_path" class="alert alert-warning"
             role="alert">
          Se ha cargado previamente una <strong>
          <a :href="`/${questionnaire.biological_sample_transfer_letter_path}`"
             target="_blank">
            Carta responsiva</a></strong>, para cambiar este archivo de click en "Seleccione la carta responsiva"
        </div>
        
        <div class="custom-file">
          <input id="biological_sample_transfer_letter"
                 ref="biological_sample_transfer_letter"
                 accept="application/pdf"
                 class="custom-file-input"
                 data-id="biological_sample_transfer_letter"
                 data-info="biological_sample_transfer_letter_info"
                 data-target="biological_sample_transfer_letter"
                 data-text="Incorpore la carta responsiva de la(s) Institución(es) colaboradora(s) por el manejo de muestras y la adecuada disposición de los residuos."
                 name="biological_sample_transfer_letter"
                 type="file"
                 @change="setFile('biological_sample_transfer_letter')">
          <label class="custom-file-label" for="biological_sample_transfer_letter">Seleccione la carta
                                                                                   responsiva</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import CellLinesList from './CellLinesList'
  import MicroorganismsList from './MicroorganismsList'
  import { AlertManager } from '../../../utils/AlertManager'
  import autosize from 'autosize'
  
  export default {
    name: 'SectionTwo',
    components: {
      CellLinesList,
      MicroorganismsList,
    },
    props: {
      questionnaire: Object,
    },
    data: () => ({
      fields: {
        question_5: [
          'microorganisms_rpbi_type',
          'microorganisms_waste_disposal_methods',
          'microorganisms_place_frequency_of_disposal',
        ],
        question_6: [
          'biological_samples_place_for_sampling',
          'biological_samples_place_to_process',
          'biological_samples_rpbi_type',
          'biological_samples_removal_methods',
          'biological_samples_place_frequency_of_disposal',
        ],
        question_7: [
          'cell_line_culture_rpbi_type',
          'cell_line_culture_removal_methods',
          'cell_line_culture_place_frequency_of_disposal',
        ],
        question_8: [
          'genetically_modified_material',
          'genetically_modified_material_nature',
          'genetically_modified_material_xenotransplantation',
          'genetically_modified_material_risks',
          'genetically_modified_material_removal_methods',
          'genetically_modified_place_frequency_of_disposal',
        ],
        question_9: [
          'environmental_samples_type',
          'environmental_samples_risks',
          'environmental_samples_rpbi_type',
          'environmental_samples_disposal_methods',
          'environmental_samples_place_frequency_of_disposal',
        ],
        question_10: [
          'biological_sample_transfer_origin',
          'biological_sample_transfer_destination',
          'biological_sample_transfer_classification',
          'biological_sample_transfer_packing_type',
          'biological_sample_transfer_conveyance',
          'biological_sample_transfer_responsible_for_shipping',
          'biological_sample_transfer_responsible_for_receiving',
          'biological_sample_transfer_periodicity',
          'biological_sample_transfer_letter',
        ],
      },
    }),
    methods: {
      addValidation (question) {
        const $formBio = $('.biosecurity-form')
        
        this.fields[question].forEach(field => {
          $formBio.find(`#${field}`).rules('add', {
            required: true,
            messages: {
              required: 'Este campo es requerido',
            },
          })
        })
        
        this.questionnaire[question] = true
      },
      removeValidation (question, value = false) {
        const $formBio = $('.biosecurity-form')
        
        this.fields[question].forEach(field => {
          $formBio.find(`#${field}`).rules('remove')
        })
        
        this.questionnaire[question] = value
      },
      setFile (field) {
        const file = this.$refs[field].files[0]

        if(file.type.indexOf('pdf') === -1) {
          AlertManager.error(`El formato del archivo ${file.name} no es aceptado. Seleccione un archivo PDF`, {
            timeout: 10000,
          })

          $(this.$refs[field]).val('')
          
          return
        }
        
        if (!this.checkFileSize(file)) {
          AlertManager.error(`El tamaño máximo de archivo es de ${ (this.isAdmin() ? 5 : 2) }MB`)
          
          $(this.$refs[field]).val('')

          return
        }
        
        if(!this.checkFileType(file)) {
          AlertManager.error('Seleccione un archivo PDF.')
          
          $(this.$refs[field]).val('')

          return
        }

        this.questionnaire[field] = file
      },
      checkFileSize(file) {
        let maxFileSize = (this.isAdmin() ? 5 : 2) * 1024 * 1024 // 2MB
        
        const fileSize  = file.size
        
        return fileSize <= maxFileSize;
      },
      checkFileType(file) {
        const extension = file.name.slice((Math.max(0, file.name.lastIndexOf('.')) || Infinity) + 1)
        
        return !(extension && extension.toLowerCase() !== 'pdf');
      },
      addValidationByCheckbox ($event, field) {
        const $formBio = $('.biosecurity-form')
        
        if ($event.target.checked) {
          $formBio.find(`[name="${field}"]`).rules('add', {
            required: true,
            messages: {
              required: 'Este campo es requerido',
            },
          })
        }
        else {
          $formBio.find(`[name="${field}"]`).rules('remove')
        }
      },
      isAdmin () {
        const roles = ['root', 'administrador']
        
        return this.user && this.user.roles && this.user.roles.some(role => roles.includes(role.key))
      },
    },
    computed: {
      openTabTwo () {
        return [this.questionnaire.question_1, this.questionnaire.question_2]
      },
      ...mapGetters(['user']),
    },
    watch: {
      openTabTwo () {
        if (!this.questionnaire.question_1 && !this.questionnaire.question_2) {
          for (let field in this.fields) {
            if (this.questionnaire[field] === null) {
              this.questionnaire[field] = null
              this.removeValidation(field, null)
            }
          }
          
          if (!this.questionnaire.question_6) {
            const $formBio = $('.biosecurity-form')
            
            this.questionnaire.biological_samples       = []
            this.questionnaire.biological_samples_types = []
            
            $formBio.find('[name="biological_samples_other"]').rules('remove')
            $formBio.find('[name="biological_samples_biopsy"]').rules('remove')
            $formBio.find('[name="biological_samples_culture"]').rules('remove')
            $formBio.find('[name="biological_samples_other_types"]').rules('remove')
          }
        }
      },
    },
    mounted () {
      const vm = this
  
      autosize($('textarea', this.$el))
      
      $('[name="biological_samples"]').rules('add', {
        required: function () {
          return !!vm.questionnaire.question_6
        },
        messages: {
          required: 'Este campo es requerido',
        },
      })
      
      $('[name="biological_samples_types"]').rules('add', {
        required: function () {
          return !!vm.questionnaire.question_6
        },
        messages: {
          required: 'Este campo es requerido',
        },
      })
      
      $('[name="microorganisms_hidden"]').rules('add', {
        required: function () {
          return !!vm.questionnaire.question_5 && vm.questionnaire.microorganisms.length < 1
        },
        messages: {
          required: 'Este campo es requerido',
        },
      })
      
      $('[name="cell_lines_hidden"]').rules('add', {
        required: function () {
          return !!vm.questionnaire.question_7 && vm.questionnaire.cell_lines.length < 1
        },
        messages: {
          required: 'Este campo es requerido',
        },
      })
    },
  }
</script>
